import { Icon, Tag, Text } from '@cencosud-cencommerce/paris-uikit';
import classNames from 'classnames';

import { useGetCustomerData } from '@/Application/Hooks/GetCustomerData';

interface ScheduledDeferredProps {
  title?: string;
  firstText?: string;
  secondText?: string;
  price?: string;
  crossedOutPrice?: string;
  selected?: boolean;
}

const ScheduledDeferred: React.FC<ScheduledDeferredProps> = ({
  title,
  firstText,
  secondText,
  price,
  crossedOutPrice,
  selected
}) => {
  const { email } = useGetCustomerData();

  let priceValue;
  if (price) {
    priceValue = price;
  } else if (!price && crossedOutPrice && !selected) {
    priceValue = crossedOutPrice;
  } else {
    priceValue = undefined;
  }

  return (
    <div className="co-flex co-flex-col co-w-full">
      <div className="co-pt-4 co-px-4 co-pb-4">
        <Text variant="body2" weight={600}>
          {title}
        </Text>
      </div>

      <div className="co-flex co-items-start co-border-t co-border-t-neutral-300 co-gap-3 tablet_w:co-py-6 tablet_w:co-px-4">
        <div
          className={classNames(
            'co-flex co-gap-4 co-bg-neutral-100 co-rounded-lg co-p-2',
            'tablet_w:co-px-4 tablet_w:co-py-2'
          )}
        >
          <Icon
            name="il-email"
            className="co-h-8 co-w-8 tablet_w:co-h-11 tablet_w:co-w-11"
          />
          <div className="co-flex co-flex-col">
            <Text variant="body2" color="primary-500" weight={600}>
              {firstText}
            </Text>
            <Text variant="caption">{secondText}</Text>
            <Text variant="caption" weight={600}>
              {email}
            </Text>
          </div>
        </div>

        <div className="co-flex co-items-center co-justify-center co-gap-2">
          {crossedOutPrice && selected && (
            <Text
              variant="caption"
              weight={500}
              color="neutral-900"
              className="co-line-through"
            >
              {crossedOutPrice}
            </Text>
          )}
          {priceValue && (
            <Text variant="body2" weight={700} color="primary-500">
              {priceValue}
            </Text>
          )}
          {!priceValue && <Tag>Gratis</Tag>}
        </div>
      </div>
    </div>
  );
};

export default ScheduledDeferred;
